import LayoutPage from '@/components/Layout/LayoutPage';
import { useConsultingEngagementsEnabled } from '@/features/consulting-engagements/featureFlag';
import ApprovalsPage from '@/features/consulting-engagements/live/ApprovalsPage';
import NotFoundPage from '@/pages/NotFoundPage';

/**
 * `/approvals` — the governance approver's queue.
 *
 * The gate lives here rather than inside `ApprovalsPage` so the dark case
 * renders the standalone 404 page — `NotFoundPage` brings its own `Layout`, and
 * nesting it inside `LayoutPage` would double-wrap the chrome.
 */
export default function ApprovalsRoute(): JSX.Element {
  if (!useConsultingEngagementsEnabled()) return <NotFoundPage />;
  return (
    <LayoutPage showNav>
      <ApprovalsPage />
    </LayoutPage>
  );
}
